import React from "react";
import Hero from "./components/Hero";
import SocialProof from "./components/SocialProof";
import Features from "./components/Features";
import HowItWorks from "./components/HowItWorks";
import CTA from "./components/CTA";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";
import "./App.css";

function App() {
  return (
    <div className="lk-root">
      <Hero />
      <SocialProof />
      <Features />
      <HowItWorks />
      <CTA />
      <FAQ />
      <Footer />
    </div>
  );
}

export default App;
